module.exports = __webpack_public_path__ + "static/media/step-5.2092a511.png";